import{eb as a,fb as b,gb as c,hb as d}from"./chunk-XC7HBXGH.js";import"./chunk-7AHD6BL4.js";import"./chunk-OP4R5AHS.js";import"./chunk-3PZV6T5Z.js";d();export{a as Faker,c as default,b as faker};
